export function parseJwt(token) {
  try {
    const base64Url = token.split(".")[1];
    const base64 = atob(base64Url.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(decodeURIComponent(escape(base64)));
  } catch (e) {
    console.error("JWT 解碼失敗", e);
    return null;
  }
}